import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { PartnerHeader } from '../partnerWeb_Dashboard/partnerHeader';
import { PartnerBodyWeb } from './partnerBodyWeb';
import { AdditionalDetailsSubmit, ArnInputAction, ArnSelectAction, ArnSubmitAction, CityGoBack, CitySelectionNav, DisableSubmit, empanelUs, GetOtp, getPassword, GoToFaq, GoToHome, GoToPhone, GoToPhoneNumber, GoToPrivacy, goToPrivacyAction, goToTermAction, GoToWhatsapp, loginPassword, loginWithOTPRedirect, loginWithPasswordEntry, OnChangeInput, PhoneNumberAction, SelectCity, SuccessEmail, ToggleCTA, VerifyOtp, WhatsappToggle, } from './actions';
import { ACTION } from './types';
import { QUERY_PARAMS } from '../../configs/constants';
import { partnerApi, StoreKey } from '../../configs/api';
import { isMobile, setAppHeader } from '../../configs/utils';
import { PartnerBodyMob } from './PartnerBodyMob';
import { navigateByUrl } from "../partnerWeb_Dashboard/utils";
import { getAppHeader, getAuthHeaders } from "../../configs/config";
import { BUILD_TYPE, getBuildType } from "../../SharedPropsService";
import SharedPropsService from "../../SharedPropsService";
import AsyncStorage from "@react-native-async-storage/async-storage";
export const template = async (path, partnerName, partnerPhoneNumber, _isMobile, refCode, cityData, referredPartner, showEmailScreen, metaData, termsLink, privacyLink, partnerAccountType, showARNScreen = false) => ({
    layout: {
        id: ROUTE.PARTNER_SIGNUP,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true,
        },
        widgets: [
            {
                id: 'partnerHeader',
                type: WIDGET.STACK,
                position: POSITION.ABSOLUTE_TOP,
            },
            _isMobile
                ? { id: 'partnerBodyMob', type: WIDGET.STACK }
                : { id: 'partnerBodyWeb', type: WIDGET.STACK },
        ],
    },
    datastore: {
        ...(await PartnerHeader(ROUTE.PARTNER_SIGNUP, {
            routeId: ROUTE.PARTNER_SIGNUP,
            type: 'PROXY',
            payload: {
                partnerAccountType: partnerAccountType
            }
        })),
        ...(_isMobile
            ? await PartnerBodyMob(path, partnerName, partnerPhoneNumber, refCode, cityData, referredPartner, metaData, showEmailScreen, termsLink, privacyLink, partnerAccountType)
            : await PartnerBodyWeb(path, partnerName, partnerPhoneNumber, refCode, cityData, referredPartner, metaData, showEmailScreen, termsLink, privacyLink, partnerAccountType, showARNScreen)),
    },
});
export const PartnerSignUpPage = {
    onLoad: async ({ setDatastore, network, metaData, navigate, asyncStorage, openNewTab, instrumentTrack, addUseProperty }, { route, partnerAccountType }) => {
        await AsyncStorage.removeItem("PLJ_borrowerAccountId");
        const path = route?.path;
        const params = route?.params;
        await setAppHeader(null, addUseProperty);
        const refCode = params?.[QUERY_PARAMS.REF];
        const referredPartner = params?.[QUERY_PARAMS.REFERRED_PARTNER];
        let partnerName = '';
        let partnerPhoneNumber = '';
        const header = await getAuthHeaders();
        header['X-EntityType'] = 'PARTNER';
        header['X-AppPlatform'] = await SharedPropsService.getAppPlatform();
        if (refCode) {
            const response = await network.get(`${partnerApi.getPartnerName}${refCode}`, { headers: header }, async () => {
                return;
            }, {
                isPartnerPlatform: true,
            });
            if (response?.status === 200) {
                partnerName = response?.data?.name;
                partnerPhoneNumber = response?.data?.mobileNumber;
            }
        }
        // const _user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
        const accessToken = await asyncStorage.get(StoreKey.accessToken);
        let partnerEmail = undefined;
        let showEmailScreen = false;
        let showARNScreen = false;
        if (accessToken && !refCode) {
            const header = await getAppHeader();
            header['X-AppPlatform'] = await SharedPropsService.getAppPlatform();
            const response = await network.post(partnerApi.userContext, {}, { headers: header }, async () => {
                return;
            }, {
                isPartnerPlatform: true,
            });
            if (response["status"] === 200) {
                await asyncStorage.set(StoreKey.userContext, JSON.stringify(response?.data));
                const _user = response?.data;
                partnerEmail = _user?.linkedPartnerAccounts[0]?.accountHolderEmail;
                const partnerAccountId = _user?.linkedPartnerAccounts[0]?.accountId;
                if (partnerEmail && partnerEmail !== '') {
                    //insert code here for the ARN logic
                    const partnerAccountDetailResponse = await network.get(`${partnerApi.clientList}${partnerAccountId}`, {
                        headers: header
                    }, async () => {
                        return;
                    }, {
                        isPartnerPlatform: true
                    });
                    await asyncStorage.set(StoreKey.userContext, JSON.stringify(response?.data));
                    if (referredPartner) {
                        await navigateByUrl(ROUTE.PARTNER_REFERRED_PARTNER, openNewTab);
                        return;
                    }
                    else {
                        await navigateByUrl(ROUTE.PARTNER_DASHBOARD_V2, openNewTab);
                        return;
                    }
                }
                else {
                    //show additional detail page.
                    showEmailScreen = true;
                    await setDatastore(ROUTE.PARTNER_SIGNUP, 'signupComponentContainer', {
                        hide: true,
                    });
                    await setDatastore(ROUTE.PARTNER_SIGNUP, 'otpComponentContainer', {
                        hide: true,
                    });
                    await setDatastore(ROUTE.PARTNER_SIGNUP, 'additionalDetailContainer', {
                        hide: false,
                    });
                }
            }
        }
        let cityData = [];
        const Authheader = await getAuthHeaders();
        Authheader['X-EntityType'] = 'PARTNER';
        Authheader['X-AppPlatform'] = await SharedPropsService.getAppPlatform();
        const response_City = await network.get(`${partnerApi.getCityDetails}`, {
            headers: Authheader,
        }, async () => {
            return;
        }, {
            isPartnerPlatform: true,
        });
        if (response_City?.status === 200) {
            cityData = response_City?.data;
        }
        const _isMobile = isMobile();
        const termsLink = getBuildType() === BUILD_TYPE.PARTNER_PRODUCTION ? 'https://voltmoney.in/terms/' : 'https://staging.voltmoney.in/terms/';
        const privacyLink = getBuildType() === BUILD_TYPE.PARTNER_PRODUCTION ? 'https://voltmoney.in/privacy/' : 'https://staging.voltmoney.in/privacy/';
        instrumentTrack('PARTNER_SIGNUP_PAGE_VIEWED', {
            "referrer_code": refCode ? refCode : null,
        });
        // --- Need refactor ---- //
        return Promise.resolve(template(path, partnerName, partnerPhoneNumber, _isMobile, refCode, cityData, referredPartner, showEmailScreen, metaData, termsLink, privacyLink, partnerAccountType, showARNScreen));
    },
    actions: {
        [ACTION.PHONE_NUMBER]: PhoneNumberAction,
        [ACTION.ENABLE_CONTINUE_PHONE_NUMBER]: ToggleCTA,
        [ACTION.DISABLE_CONTINUE_PHONE_NUMBER]: ToggleCTA,
        [ACTION.PRIVACY]: GoToPrivacy,
        [ACTION.WHATSAPP_CHECK]: WhatsappToggle,
        [ACTION.WHATSAPP_UNCHECK]: WhatsappToggle,
        [ACTION.GET_OTP]: GetOtp,
        [ACTION.GO_TO_PHONE_NUMBER_ACTION]: GoToPhoneNumber,
        [ACTION.RE_SEND_OTP]: GetOtp,
        [ACTION.VERIFY_OTP]: VerifyOtp,
        [ACTION.CHANGE_INPUT]: OnChangeInput,
        [ACTION.DISABLE_SUBMIT]: DisableSubmit,
        [ACTION.SWITCH_TO_CITY_SELECTION]: CitySelectionNav,
        [ACTION.SELECT_CITY]: SelectCity,
        [ACTION.ADDITIONAL_DETAIL]: AdditionalDetailsSubmit,
        [ACTION.GO_TO_HOME]: GoToHome,
        [ACTION.GO_TO_FAQ]: GoToFaq,
        [ACTION.GO_TO_CALL]: GoToPhone,
        [ACTION.GO_TO_WHATSAPP]: GoToWhatsapp,
        [ACTION.CITY_GO_BACK]: CityGoBack,
        [ACTION.EMAIL_SUCCESS]: SuccessEmail,
        [ACTION.LOGIN_WITH_PASSWORD_ENTRY]: loginWithPasswordEntry,
        [ACTION.GET_PASSWORD]: getPassword,
        [ACTION.LOGIN_WITH_OTP_REDIRECT]: loginWithOTPRedirect,
        [ACTION.LOGIN_PASSWORD]: loginPassword,
        [ACTION.EMPANEL_US]: empanelUs,
        [ACTION.ARN_CHECK_ACTION]: ArnSelectAction,
        [ACTION.ARN_INPUT_ACTION]: ArnInputAction,
        [ACTION.ARN_SUBMIT_ACTION]: ArnSubmitAction,
        [ACTION.PRIVACY_POLICY]: goToPrivacyAction,
        [ACTION.T_AND_C]: goToTermAction,
    },
};
